function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("pattern", {
  patternTransform: "matrix(10 0 0 10 -2019.007 -304.36)",
  id: "d",
  xlinkHref: "#a"
}), React.createElement("pattern", {
  patternUnits: "userSpaceOnUse",
  width: 2,
  height: 1,
  patternTransform: "scale(10)",
  id: "a"
}, React.createElement("path", {
  d: "M0-.5h1v2H0z"
})), React.createElement("pattern", {
  id: "b",
  patternTransform: "translate(2019.007 304.36)",
  height: 933.23,
  width: 1082.786,
  patternUnits: "userSpaceOnUse"
}, React.createElement("path", {
  fill: "url(#d)",
  fillRule: "evenodd",
  strokeWidth: 7.69,
  strokeLinecap: "round",
  strokeLinejoin: "bevel",
  paintOrder: "fill markers stroke",
  d: "M0 0h1082.786v933.23H0z"
})), React.createElement("linearGradient", {
  id: "c",
  gradientUnits: "userSpaceOnUse",
  x1: 534.3,
  y1: 433.2,
  x2: 998.1,
  y2: 433.2
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0.2
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0.02
})), React.createElement("linearGradient", {
  y2: 433.2,
  x2: 998.1,
  y1: 433.2,
  x1: 534.3,
  gradientUnits: "userSpaceOnUse",
  id: "e",
  xlinkHref: "#c"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M931.7 998.3c36.5 0 66.4-29.4 66.4-65.4V265.8c0-36-29.9-65.4-66.4-65.4H283.6l260.1 797.9z",
  fill: "#dbdbdb"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M931.7 230.4c9.7 0 18.9 3.8 25.8 10.6 6.8 6.7 10.6 15.5 10.6 24.8v667.1c0 9.3-3.7 18.1-10.6 24.8-6.9 6.8-16.1 10.6-25.8 10.6H565.5L324.9 230.4h606.8m0-30H283.6l260.1 797.9h388c36.5 0 66.4-29.4 66.4-65.4V265.8c0-36-29.9-65.4-66.4-65.4z",
  fill: "#dcdcdc"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#007ac1",
  d: "M543.7 998.3l170.7-188.5H482.3z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#5a7788",
  strokeWidth: 7.6898,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  paintOrder: "fill markers stroke",
  d: "M541.181 496.886h393.593v204.928H541.181z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M541.181 599.35l196.797-102.464L934.774 599.35 737.978 701.814z",
  fill: "#5a7788"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M66.4 0C29.9 0 0 29.9 0 66.5v677c0 36.5 29.9 66.4 66.4 66.4h648.1L454.4 0z",
  fill: "#03a9f4"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M534.3 200.4h397.4c36.5 0 66.4 29.4 66.4 65.4V666z",
  fill: "url(#e)"
});

var SvgFlag = function SvgFlag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 998.1 998.3",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, React.createElement("text", {
    style: {
      lineHeight: 1.25
    },
    x: 146.038,
    y: 561.906,
    fontWeight: 400,
    fontSize: 40,
    fontFamily: "sans-serif",
    letterSpacing: 0,
    wordSpacing: 0,
    fill: "#eee"
  }, React.createElement("tspan", {
    x: 146.038,
    y: 561.906,
    style: {
      InkscapeFontSpecification: "'Roboto, Medium'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start"
    },
    fontWeight: 500,
    fontSize: 440,
    fontFamily: "Roboto"
  }, "F")));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFlag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flag.16c4fb8b.svg";
export { ForwardRef as ReactComponent };